export default {
  setCollapse(state, bool) {
    state.menuState.collapsed = bool;
  }
};
